import { h, Component } from 'preact';
import { Router } from 'preact-router';

import Header from './header';

// Code-splitting is automated for routes
import Home from '../routes/home';

import FontLoader from '../tools/fonts';

export default class App extends Component {
    /** Gets fired when the route changes.
     *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
     *	@param {string} event.url	The newly routed URL
     */
    handleRoute = (e) => {
        this.currentUrl = e.url;
    };

    componentDidMount() {
        const fonts = new FontLoader([
            { name: 'Quicksand', weight: 400 },
            { name: 'Quicksand', weight: 700 },
        ]);

        fonts.load();
    }

    render() {
        return (
            <div id="app">
                <Header />
                <Router onChange={this.handleRoute}>
                    <Home path="/" />
                </Router>
                <link
                    rel="stylesheet"
                    href="https://pro.fontawesome.com/releases/v5.15.4/css/all.css"
                    integrity="sha384-rqn26AG5Pj86AF4SO72RK5fyefcQ/x32DNQfChxWvbXIyXFePlEktwD18fEz+kQU"
                    crossorigin="anonymous"
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/app.js